import { useState, useEffect } from "react";
import { Menu, X, PhoneCall } from "lucide-react";
import { NAV_LINKS, CONTACT } from "../data";

export const Header = () => {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 10);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 w-full z-50 bg-white border-b-2 border-[#09090B] transition-shadow ${
        scrolled ? "shadow-[0_4px_0_0_rgba(220,38,38,1)]" : ""
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
        {/* Mobile: quick call button (left) */}
        <a
          data-testid="mobile-header-call-top"
          href={CONTACT.phoneLink}
          className="md:hidden flex items-center gap-2 bg-[#DC2626] text-white font-anton uppercase tracking-wider text-sm px-4 py-2"
        >
          <PhoneCall size={16} /> Zadzwoń
        </a>

        <nav className="hidden md:flex flex-1 items-center justify-center gap-8">
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`nav-${l.id}`}
              onClick={() => go(l.id)}
              className="font-anton text-lg tracking-wide uppercase text-[#09090B] hover:text-[#DC2626] transition-colors"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <a
          data-testid="header-cta-call"
          href={CONTACT.phoneLink}
          className="hidden md:flex items-center gap-2 bg-[#DC2626] text-white font-anton uppercase tracking-wider px-6 py-2.5 border-2 border-[#DC2626] hover:bg-[#09090B] hover:border-[#09090B] transition-colors"
        >
          <PhoneCall size={18} /> Zadzwoń teraz
        </a>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen((v) => !v)}
          className="md:hidden text-[#09090B]"
          aria-label="Menu"
        >
          {open ? <X size={28} /> : <Menu size={28} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-white border-t-2 border-[#09090B] px-4 py-4 flex flex-col gap-1"
        >
          {NAV_LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={`mobile-nav-${l.id}`}
              onClick={() => go(l.id)}
              className="text-left font-anton text-xl uppercase py-2 text-[#09090B] hover:text-[#DC2626]"
            >
              {l.label}
            </button>
          ))}
          <a
            data-testid="mobile-header-cta"
            href={CONTACT.phoneLink}
            className="mt-2 bg-[#DC2626] text-white font-anton uppercase tracking-wider px-6 py-3 flex items-center justify-center gap-2"
          >
            <PhoneCall size={18} /> Zadzwoń teraz
          </a>
        </div>
      )}
    </header>
  );
};
